/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Sponsorship_BannerInputs */



/**
* | output |
* | --- |
* | "Want to play in sanctioned tournaments? You need a VEKN ID — ask a VEKN official to sponsor you." |
*
* @param {Profile_Sponsorship_BannerInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const profile_sponsorship_banner = /** @type {((inputs?: Profile_Sponsorship_BannerInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Sponsorship_BannerInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Vous souhaitez jouer dans des tournois sanctionnés ? Vous avez besoin d'un VEKN ID — demandez à un officiel VEKN de vous parrainer.")
	if (locale === "es") return /** @type {LocalizedString} */ ("¿Quieres jugar en torneos sancionados? Necesitas un ID VEKN — pide a un oficial de VEKN que te patrocine.")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Quer jogar em torneios sancionados? Você precisa de um ID VEKN — peça a um oficial da VEKN para te patrocinar.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Vuoi partecipare a tornei sanzionati? Hai bisogno di un VEKN ID — chiedi a un ufficiale VEKN di sponsorizzarti.")
	return /** @type {LocalizedString} */ ("Want to play in sanctioned tournaments? You need a VEKN ID — ask a VEKN official to sponsor you.")
});